import {HttpStatusCode} from '@angular/common/http';
import {EMPTY, Observable, Observer, Subscription} from 'rxjs';
import {extractRequestId} from '../infra/common-error.handler';

export function subscribeWithOptionalMute<T>(
    observable: Observable<T>,
    next: (value: T) => void,
    muteAndLog: boolean,
): Subscription {
    return muteAndLog
        ? observable.subscribe(muteAndLogError(next))
        : observable.subscribe(next);
}

export function muteAndLogError<T>(next: (value: T) => void): Partial<Observer<T>> {
    return {
        next,
        error: (error) => {
            if (error.status === HttpStatusCode.Unauthorized || error.status === HttpStatusCode.Forbidden) {
                throw error;
            }
            console.error('HTTP request failed', {
                url: safeUrl(error.url),
                status: error.status,
                requestId: extractRequestId(error),
            });
            return EMPTY;
        },
    };
}

export function safeUrl(url?: string | null): string | undefined {
    if (!url) {
        return undefined;
    }
    try {
        const u = new URL(url);
        return `${u.origin}${u.pathname}`;
    } catch {
        return undefined;
    }
}
